import { render, staticRenderFns } from "./CreateNewBookYearModal.vue?vue&type=template&id=c548a6a8"
import script from "./CreateNewBookYearModal.vue?vue&type=script&lang=ts"
export * from "./CreateNewBookYearModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c548a6a8')) {
      api.createRecord('c548a6a8', component.options)
    } else {
      api.reload('c548a6a8', component.options)
    }
    module.hot.accept("./CreateNewBookYearModal.vue?vue&type=template&id=c548a6a8", function () {
      api.rerender('c548a6a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookyear/CreateNewBookYearModal.vue"
export default component.exports